import { useEffect, useState } from "react";
import * as Constants from "../../constants/urls";
import axios from "axios";
import { useCookies } from "react-cookie";
import Header from "../Header/Header";
import { Drawer } from "@material-ui/core";
import RightMenu from "../RightMenu";
import { toast } from "react-toastify";
import Breadcrumb from "../Breadcrumb/Breadcrumb";

const PostPrice = () => {
    const [price, setPrice] = useState(0);
    const [cookies, setCookie, removeCookie] = useCookies();
    const [state, setState] = useState({ right: false });
    const [filter, setFilter] = useState([]);


    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };


    function getData() {

        const url = Constants.apiUrl + "/api/setting/post_price";
        axios.post(url, {},{
            headers: {
                Authorization: "Bearer " + cookies.user_server_token,
            },
        })
            .then((r) => {
                setPrice(r.data.post_price);
            })
            .catch((e) => {

            });
    }

    function setPostPrice() {

        const url = Constants.apiUrl + "/api/setting/post_price_change";
        axios.post(url, {
            status:price
        },{
            headers: {
                Authorization: "Bearer " + cookies.user_server_token,
            },
        })
            .then((r) => { 
                toast.success(" تغییرات با موفقیت انجام شد " );

            })
            .catch((e) => {

            });
    }
    useEffect(() => {
        getData();
    }, [])
    return (<>

<Breadcrumb title={"تنظیمات"} />

        <div className="container" style={{ direction: "rtl" }}>
            <div className="row text-center py-5">
                <label>
                    محاسبه قیمت تاپین
                </label>
                <select className="form-control" onChange={(e)=>{setPrice(e.target.value)}}>
                    <option value={1} selected={price == 1}>
                        از طریق api
                    </option>
                    <option value={0} selected={price == 0}>
                        دستی
                    </option>
                </select>
                <button className="btn btn-success btn-block my-2" onClick={setPostPrice}>
                    ثبت
                </button>
            </div>
        </div>
    </>)

}
export default PostPrice;